// extracted by mini-css-extract-plugin
export default {"label":"CustomSelectorReduxForm-module__label___AJ36x","error":"CustomSelectorReduxForm-module__error___wpGj3"};